export default __webpack_public_path__ + "static/media/demo_delidding.db9d2fcc.png";